<template>
  <transition name="cookie-fade">
    <div v-if="visible" class="cookie-banner">
      <div class="cookie-banner__content">
        <p class="cookie-banner__text mb-0">
          {{ $t('legal.cookieBannerText') }}
          <router-link :to="{ name: 'foravila-cookie-policy' }" class="cookie-banner__link">
            {{ $t('legal.cookieBannerLearnMore') }}
          </router-link>
        </p>
        <b-button
          variant="primary"
          size="sm"
          class="cookie-banner__btn ml-md-3 mt-2 mt-md-0"
          @click="accept"
        >
          {{ $t('legal.cookieBannerAccept') }}
        </b-button>
      </div>
    </div>
  </transition>
</template>

<script>
import { BButton } from 'bootstrap-vue'

const COOKIE_CONSENT_KEY = 'foravilaCookieConsent'

export default {
  components: { BButton },
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    if (!localStorage.getItem(COOKIE_CONSENT_KEY)) {
      this.visible = true
    }
  },
  methods: {
    accept() {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: #2c3e50;
  color: #fff;
  padding: 14px 24px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.2);

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 auto;
    gap: 8px;
  }

  &__text {
    font-size: 0.875rem;
    flex: 1;
  }

  &__link {
    color: #8ab4f8;
    text-decoration: underline;
    white-space: nowrap;

    &:hover {
      color: #aecbfa;
    }
  }

  &__btn {
    flex-shrink: 0;
    white-space: nowrap;
  }
}

.cookie-fade-enter-active,
.cookie-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.cookie-fade-enter,
.cookie-fade-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>
